import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  dropDown: {
    margin      : theme.spacing(0),
    marginRight : theme.spacing(2),
    width       : '230px',

  },
}));